import React, { useEffect } from 'react';

const About = () => {
  // Scroll to top on page load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const leadershipTeam = [
    { id: 1, name: 'Harsh Jain', designation: 'Co-founder & CEO, Dream Sports', image: '/team/harsh-jain.png' },
    { id: 2, name: 'Bhavit Sheth', designation: 'Co-founder & COO, Dream Sports', image: '/team/bhavit-sheth.png' },
    { id: 3, name: 'Deepak Jacob', designation: 'President Corporate Affairs, Dream Sports', image: '/team/deepak-jacob.png' },
    { id: 4, name: 'Neel Shah', designation: 'CEO, Dream Sports Foundation', image: '/team/neel-shah.png' },
  ];

  const managementTeam = [
    { id: 1, name: 'Sumit Pandey', designation: 'COO, Dream Sports Foundation', image: '/team/sumit-pandey.png' },
    { id: 2, name: 'Navin Fernandes', designation: 'AVP, Programs & Partnerships', image: '/team/navin-fernandes.png' },
    { id: 3, name: 'Abhinn Kothari', designation: 'Lead, Sports Technology', image: '/team/abhinn-kothari.png' },
    { id: 4, name: 'Dheeraj', designation: 'Sr. Manager, Performance', image: '/team/dheeraj.png' },
    { id: 5, name: 'Nimisha Paul', designation: 'Sr. Manager, Programs', image: '/team/nimisha-paul.png' },
    { id: 6, name: 'Prashant Tayde', designation: 'Manager, Programs', image: '/team/prashant-tayde.png' },
    { id: 7, name: 'Nishieth Babu', designation: 'Manager, Programs', image: '/team/nishieth-babu.png' },
  ];

  return (
    <div className="about-page">
      <section className="page-banner-section grunge-texture">
        <div className="page-banner-image">
          <img 
            src="/about-banner.png" 
            alt="Dream Sports Foundation About Us"
            className="page-banner-img"
          />
        </div>
      </section>

      <section className="about-grid-section grunge-texture">
        <div className="about-container">
          <div className="about-2x2-grid">
            {/* Row 1: Text Box + Image */}
            <div className="about-text-box">
              <h2 className="about-box-heading">About Us</h2>
              <p className="about-box-text">
                We are the sport development arm of India's leading sports technology organisation, Dream Sports. We create inclusive, sustainable, and measurable impact through programs that support young athletes, powered by sports science and technology.
              </p>
            </div>
            <div className="about-image-box">
              <video 
                src="/about-us.mp4" 
                poster="/about-us-poster.jpg"
                className="about-grid-image"
                autoPlay 
                loop 
                muted 
                playsInline
              />
            </div>

            {/* Row 2: Image + Text Box */}
            <div className="about-image-box">
              <video 
                src="/vision.mp4" 
                poster="/vision-poster.jpg"
                className="about-grid-image"
                autoPlay 
                loop 
                muted 
                playsInline
              />
            </div>
            <div className="about-text-box">
              <h2 className="about-box-heading">Our Vision</h2>
              <p className="about-box-text">
                Make sports a viable career pathway in India.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="team-section grunge-texture">
        <div className="about-container">
          <div className="section-header">
            <h2 className="heading-2">Our Team</h2>
          </div>
          
          {/* Leadership */}
          <div className="team-category">
            <h3 className="team-category-title">Leadership</h3>
            <div className="team-grid leadership-grid">
              {leadershipTeam.map((member) => (
                <div key={member.id} className="team-member">
                  <div className="team-member-image">
                    <img src={member.image} alt={member.name} />
                  </div>
                  <h4 className="team-member-name">{member.name}</h4>
                  <p className="team-member-designation">{member.designation}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Management */}
          <div className="team-category">
            <h3 className="team-category-title">Management</h3>
            <div className="team-grid management-grid">
              {managementTeam.map((member) => (
                <div key={member.id} className="team-member">
                  <div className="team-member-image">
                    <img src={member.image} alt={member.name} />
                  </div>
                  <h4 className="team-member-name">{member.name}</h4>
                  <p className="team-member-designation">{member.designation}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;